"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KesCloudWorkspacesService = void 0;
class KesCloudWorkspacesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1KescloudWorkspacesIds() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/kescloud/workspaces/ids',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.KesCloudWorkspacesService = KesCloudWorkspacesService;
